import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnCamera } from '../camera';
import { SnUser } from '../user';

export class SnMapView extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public lat: number;

  @Expose()
  public lon: number;

  @Expose({ toPlainOnly: true })
  public geometry: any;

  @Expose()
  public meta: any;

  @Expose()
  public autoplay: boolean;

  @Expose()
  public zoomLevel: number;

  @Expose()
  public externalId: string;

  @Expose()
  public user: SnUser;

  @Expose()
  @Type(() => SnCamera)
  public cameras: any[] = [];

  @Expose()
  public type: string;

  @Expose()
  public objectId: string;

  @Expose()
  public contentType: string;

  @Expose()
  public location: any;

  @Expose()
  public isTemporary: boolean;

  @Expose()
  public vectors: any;

  @Expose()
  public dolpViewer: any[];

  @Expose()
  public dolpEditor: any[];

  @Expose()
  public dolpAdmin: any[];

  @Expose()
  public dolpShares: any[];

  @Expose()
  public dolpOwner: {
    id: string;
    name: string;
  };

  @Expose()
  public archived: boolean;

  public canDelete;
  public canArchive;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
